export default __webpack_public_path__ + "static/media/item-1-safari-14.438d0241.png";